<template>
    <div>
        <!--v-dialog v-model="qrDialog" width="500px" persistent scrollable style="max-width:340px;">
            <v-card style="margin-top:0px; border-radius:5px;">
                <v-card-title class="pt-2 blue darken-4">
                    <span style="color: white; margin-top:10px;" class="ma-3 "><strong>Scansione QR </strong></span>
                </v-card-title>
                <v-card-text class="pt-0 mt-4">
                    <div>
                        <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>

                    </div>
                </v-card-text>
                <v-card-actions class="ma-4">
                    <v-layout class="mt-4">
                        <v-layout align-center row justify-center>
                            <v-btn round primary @click="qrDialog = false">Chiudi</v-btn>
                        </v-layout>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog-->

        <v-dialog v-model="showGenDialog" width="500px" persistent scrollable style="max-width:340px;">
            <v-card style="margin-top:0px; border-radius:5px;">
                <v-card-title class="pt-2 blue darken-4">
                    <span style="color: white; margin-top:10px;" class="ma-3 "><strong>Generazione etichette
                        </strong></span>
                </v-card-title>
                <v-card-text class="pt-0 mt-4">
                    Generate {{ listaEtichette.length }} di {{ getNumSelectedRows() }}
                </v-card-text>
                <v-card-actions class="ma-4">

                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-toolbar app color="blue darken-2" dark>
            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo ml-0" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 40px"
                    @click="gotoHome()" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <!--v-icon @click="openQRCodeDialogue()">qr_code</v-icon -->
        </v-toolbar>

        <v-layout align-start row wrap justify-center class="mt-0">
            <v-flex flex xs12 sm6 md6 lg6 class="">
                <v-layout align-start justify-start class="mt-2">
                    <span class="white--text ml-3">Id Gara: {{ raceID }} - {{ nomeGara }}</span>
                </v-layout>
            </v-flex>
            <v-flex flex xs12 sm6 md6 lg6 class="">
                <v-layout align-end justify-end class="mt-1">
                    <span class="white--text mr-3 display-1">GENERATORE ETICHETTE</span>

                </v-layout>
            </v-flex>

        </v-layout>
        <v-layout align-start row justify-center class="mt-0 mb-5">

            <v-flex flex xs12 sm12 md12 lg12>
                <v-layout align-start row wrap justify-center class="mt-0">

                    <v-flex flex xs12 sm12 md12 lg12>
                        <v-layout align-start row wrap justify-center class="mt-0">
                            <v-flex flex xs12 sm2 md2 lg2 class="scroll-y" style="height: 800px">
                                <v-layout align-start row wrap justify-center class="mt-0 pa-0">
                                    <v-flex flex xs12 sm12 md12 lg12 class="red darken-2 white--text font-weight-black pa-1"
                                        style="height: 40px;">
                                        <input type="file" ref="doc" @change="readFile()" />
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12 class=" white--text font-weight-black pa-1 mb-2"
                                        style="height: 30px;" @click="filtroAtleti('tutti', '')">
                                        <span class="ml-2 pa-2 white--text">TUTTI<span style="float:right" class="mr-2">{{
                                            elencoIscritti.length }}</span></span>
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12
                                        class="blue darken-2 white--text font-weight-black pa-1" style="height: 30px;">
                                        DIVISIONI
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12 v-for="div in listaDivisioni" :key="'Divisione_' + div"
                                        @click="filtroAtleti('divisione', div)">
                                        <span class="ml-2 pa-2 white--text">{{ div }} <span style="float:right"
                                                class="mr-2">{{ mappaDivisioni[div].num }}</span></span>
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12 v-if="listaBatterie.length > 0"
                                        class="blue darken-2 white--text font-weight-black pa-1 mt-4" style="height: 30px;">
                                        BATTERIE
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12 v-for="wave in listaBatterie" :key="'Batteria_' + wave"
                                        @click="filtroAtleti('partenza onda', wave)">
                                        <span class="ml-2 pa-2 white--text">{{ wave }} <span style="float:right"
                                                class="mr-2">{{ mappaBatterie[wave].num }}</span></span>
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12
                                        class="blue darken-2 white--text font-weight-black pa-1 mt-4" style="height: 30px;">
                                        CATEGORIE
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12 v-for="cat in listaCategorie" :key="'Categoria_' + cat"
                                        @click="filtroAtleti('categoria', cat)">
                                        <span class="ml-2 pa-2 white--text">{{ cat }} <span style="float:right"
                                                class="mr-2">{{ mappaCategorie[cat].num }}</span></span>
                                    </v-flex>
                                </v-layout>



                            </v-flex>
                            <v-flex flex xs12 sm10 md10 lg10>
                                <v-layout align-start row wrap justify-center class="pa-2 black--text white">
                                    <v-flex flex xs12 sm12 md12 lg12 class="black--text">
                                        <strong class="title">{{ configurazione }}</strong><span
                                            style="float: right">selezionati {{ getNumSelectedRows() }} su {{ itemsF2.length
                                            }}</span><br> <span style="float: right"> <v-btn v-if="getNumSelectedRows() > 0 && this.raceID !== undefined"
                                                class="ml-3" color="red white--text" @click="printPrepare(true)">Genera
                                                etichette con QR</v-btn>
                                            <v-btn v-if="getNumSelectedRows() > 0 " class="ml-3" color="orange black--text"
                                                @click="printPrepare(false)">Genera etichette senza QR</v-btn><v-btn
                                                v-if="getNumSelectedRows() > 0 " class="ml-3" color="blue white--text"
                                                @click="printCiclismo()">Genera QR Ciclismo</v-btn></span>
                                    </v-flex>
                                    <v-flex flex xs12 sm12 md12 lg12 class="black--text mb-2">


                                        <span style="float: right">


                                        </span>
                                    </v-flex>


                                    <v-flex flex xs12 sm12 md12 lg12 class="black--text title mb-3">

                                        <v-layout align-start row wrap justify-center
                                            class="pa-2 black--text grey lighten-4 mt-3">


                                            <v-flex flex xs12 sm12 md12 lg12 class="black--text title mt-3 scroll-y"
                                                style="height: 600px">

                                                <v-data-table :items="itemsF2" hide-actions style="" class="mb-5">
                                                    <template slot="headers" slot-scope="props">
                                                        <tr class="mb-2"
                                                            style="background-color: #f5f5f5 !important; height:15px">
                                                            <th>#</th>
                                                            <th v-for="head in headersConfigAtleti"
                                                                class="black--text text-xs-center"><strong>{{
                                                                    head.toUpperCase() }}</strong></th>
                                                            <th>*</th>
                                                        </tr>
                                                        <tr class="mb-2"
                                                            style="background-color: #f5f5f5 !important; height:15px">
                                                            <th> <input class="mr-2" type="checkbox"
                                                                    v-model="selectAllRadio" @click="selectAll()" /></th>
                                                            <th v-for="head in headersConfigAtleti"
                                                                class="black--text text-xs-center">
                                                                <v-text-field class="white red--text ma-0 ml-1 mr-1"
                                                                    @input="changedTable"
                                                                    v-model="searchTableAtleti[head]"></v-text-field>
                                                            </th>
                                                            <th> </th>
                                                        </tr>
                                                    </template>
                                                    <template slot="items" slot-scope="props">
                                                        <tr style="height:0px">
                                                        </tr>
                                                        <tr :class="row_classes(props.item)">
                                                            <td> <input class="mr-2" type="checkbox"
                                                                    :id="props.item.property"
                                                                    v-model="props.item.checked" /></td>
                                                            <td nowrap v-for="head in headersConfigAtleti">{{
                                                                getValue(props.item,
                                                                    head) }}
                                                            </td>

                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>

                                    </v-flex>


                                </v-layout>



                            </v-flex>
                        </v-layout>

                    </v-flex>

                </v-layout>
            </v-flex>
        </v-layout>



    </div>
</template>

<script>
//import { StreamBarcodeReader } from "vue-barcode-reader";


export default {
    components: {
       // StreamBarcodeReader: StreamBarcodeReader
    },
    name: 'GenEtichette',

    data() {
        return {
            items: [],
            itemsF: [],

            itemsF2: [],

            elencoIscritti: [],
            chipReads: [],

            headers: [],

            searchText: '',

            raceID: null,
            nomeGara: '',

            connection: null,

            snackbar: 'AAA',

            myInterval: null,
            myIntervalBar: null,

            sport: '',

            popup: false,
            currentItem: undefined,

            evento: {},
            message: undefined,

            nomeCartella: '',
            templateLiveSelected: undefined,

            fileDialog: false,
            fileSelected: false,
            fileContent: '',

            tabName: 'eventi',



            selectedParticipant: undefined,
            nomeTabAtleta: 'generale',
            chipReadsAtleta: [],
            orderByField: 'pettorale',
            direction: -1,

            listaDivisioni: [],
            listaCategorie: [],
            listaBatterie: [],

            mappaDivisioni: {},
            mappaCategorie: {},
            mappaBatterie: {},

            headersConfigAtleti: ['pett', 'cognome', 'nome', 'sesso', 'categoria', 'team', 'partenza onda'],

            configurazione: "",

            searchTableAtleti: {},
            selectAllRadio: undefined,

            showModificaMultiplaDialog: false,
            fieldSelected: undefined,

            messaggio: "",
            valueSelected: "",

            configRace: undefined,

            etichetteDialog: false,

            listaEtichette: [],

            content: "",

            qrDialog: false,

            qrText: "",

            numGen: 0,

            showGenDialog: false,

            genQR: false,

            evento: {},
            nomeGara: "",

            printed: 0




        };
    },

    mounted() {
        this.raceID = this.$route.params.raceID;
        console.log(this.raceID)
        if (this.raceID !== undefined) this.loadEvento();


    },


    methods: {


        loadEvento() {
            this.getEventoBaseIcron(this.raceID).then((response) => {
                console.log('getEventoIcron:');
                if (response.esito == 'OK') {
                    // this.evento = response.evento;
                    // this.nomeGara = response.evento.descrizione;
                    this.loadPartecipanti(null, response.elencoPartecipanti);

                }
                //this.refresh(this);

                // this.myInterval = setInterval(this.refresh, 20000, this);
            });
        },

        readFile() {
            this.file = this.$refs.doc.files[0];
            const reader = new FileReader();
            if (this.file.name.includes(".csv")) {
                reader.onload = (res) => {
                    this.loadPartecipanti(res.target.result)
                };
                reader.onerror = (err) => console.log(err);
                reader.readAsText(this.file);
            } else {
                alert("Caricare file csv")

            }
        },


        onDecode(text) {
            console.log(`Decode text from QR code is ${text}`)
            alert(text)
            this.qrText = text
        },
        onLoaded() {
            console.log(`Ready to start scanning barcodes`)
        },


        annullaFiltro() {
            this.searchText = '';
            this.itemsF = this.filteredList();
        },

        orderBy(field) {
            this.orderByField = field
            this.itemsF = this.filteredList();

        },

        isSelectVisible() {
            console.log(this.fieldSelected)
            //return this.fieldsValues !== undefined && this.fieldsValues[this.fieldSelected] !== undefined
            return true;
        },


        selectAll() {
            console.log(this.selectAllRadio)
            if (!this.selectAllRadio) {
                this.itemsF2.forEach(item => {
                    item.checked = true
                })
            } else {
                this.itemsF2.forEach(item => {
                    item.checked = false
                })
            }
            this.$forceUpdate();

        },

        getNumSelectedRows() {
            return this.itemsF2.filter(item => {
                return item.checked == true
            }).length
        },

        annullaSelezione() {
            this.itemsF2.forEach(item => {
                item.checked = false
            })
            this.$forceUpdate();
        },

        openQRCodeDialogue() {
            this.qrText = "";
            this.qrDialog = true;
        },

        loadPartecipanti(_content, participants) {
            let fromNewgo = false;

            this.elencoIscritti = [];
            if (_content !== null) {
                this.elencoIscritti = this.csvJSON(_content);
            } else {
                fromNewgo = true
                this.elencoIscritti = participants
            }




            this.elencoIscritti.forEach(elem => {
                if (fromNewgo) {
                    elem['rowid'] = elem.idiscrizione;
                    elem['pett'] = elem.pettorale;
                } else {
                    elem['codiceSquadra'] = elem['codice squadra']
                }

                if (elem.squadra === undefined || elem.squadra === '') elem.squadra = elem['codiceSquadra'];




                if (elem.cognome !== undefined) elem.cognomeL = elem.cognome.substr(0, 20)
                if (elem.nome !== undefined) elem.nomeL = elem.nome.substr(0, 12)
                if (elem.squadra !== undefined) elem.squadraL = elem.squadra.substr(0, 30)


                //console.log(elem)
                this.headersConfigAtleti = Object.keys(elem);

                if (elem.rowid == undefined) {
                    alert("File non valido. Deve contenere la colonna rowid o idiscrizione")
//                } else if (elem.divisione == undefined) {
//                    alert("File non valido. Deve contenere la colonna divisione")
                    return;
                }

                if (elem.divisione !== undefined) {

                    let mdiv = this.mappaDivisioni[elem['divisione']];
                    if (mdiv === undefined && elem['divisione'] != undefined) {
                        this.mappaDivisioni[elem['divisione']] = { name: elem['divisione'], num: 1 };
                        //       console.log("Divisione aggiunta: >>" + elem['divisione'] + "<<")
                    } else {
                        mdiv['num'] = parseInt(mdiv['num']) + 1;
                        this.mappaDivisioni[elem['divisione']] = mdiv;
                    }
                }


                if (elem['partenza onda'] !== undefined) {
                    let mBatt = this.mappaBatterie[elem['partenza onda']];
                    if (mBatt === undefined && elem['partenza onda'] != undefined) {
                        this.mappaBatterie[elem['partenza onda']] = { name: elem['partenza onda'], num: 1 };
                    } else {
                        mBatt['num'] = parseInt(mBatt['num']) + 1;
                        this.mappaBatterie[elem['partenza onda']] = mBatt;
                    }
                }

                if (elem['sesso'] !== undefined && elem['categoria'] !== undefined) {
                    const _cc = elem['sesso'] + " - " + elem['categoria'];
                    let mCat = this.mappaCategorie[_cc];
                    if (mCat === undefined) {
                        this.mappaCategorie[_cc] = { name: _cc, num: 1 };
                    } else {
                        mCat['num'] = parseInt(mCat['num']) + 1;
                        this.mappaCategorie[_cc] = mCat;
                    }
                }


            })

            //if (this.configEvento.filtroDivisioni === undefined) {
            this.listaDivisioni = Object.keys(this.mappaDivisioni);
            this.listaDivisioni.sort();

            this.listaCategorie = Object.keys(this.mappaCategorie);
            this.listaCategorie.sort();

            this.listaBatterie = Object.keys(this.mappaBatterie);
            this.listaBatterie.sort();

            this.itemsF = this.filteredList();
            this.itemsF2 = this.elencoIscritti;






        },

        getValue(item, fname) {
            return item[fname.toLowerCase()]
        },

        changedSearch(event) {
            //  console.log('Changed:' + event);
            this.searchText = event;

            this.tabName = 'partecipanti'

            this.itemsF = this.filteredList();
        },

        changedTable(event) {
            console.log(event)
            console.log(this.searchTableAtleti)
            this.itemsF2 = this.filteredTable();
        },

        filteredTable() {
            let listaResult = [];

            const listaFiltri = Object.keys(this.searchTableAtleti);

            listaFiltri.forEach(filtro => {
                if (filtro == 'tipoFiltro') {
                    if (this.searchTableAtleti.tipoFiltro == 'categoria') {
                        const sex = this.searchTableAtleti.valoreFiltro.substr(0, 1);
                        const cat = this.searchTableAtleti.valoreFiltro.substr(4, this.searchTableAtleti.valoreFiltro.length - 1);
                        console.log("Filtro:>>" + sex + "<< - >>" + cat + "<<")
                        listaResult = this.elencoIscritti.filter(elem => {
                            return elem['sesso'] == sex && elem['categoria'] == cat
                        })

                    } else if (this.searchTableAtleti.tipoFiltro == 'tutti') {
                        listaResult = this.elencoIscritti
                    } else {
                        listaResult = this.elencoIscritti.filter(elem => {
                            return elem[this.searchTableAtleti.tipoFiltro] == this.searchTableAtleti.valoreFiltro
                        })
                    }
                } else {
                    if (filtro !== 'valoreFiltro') {
                        const valoreFiltro = this.searchTableAtleti[filtro]
                        if (valoreFiltro !== '') {
                            listaResult = this.elencoIscritti.filter((p) => {
                                let res =
                                    p != null &&
                                    p[filtro] != undefined &&
                                    p[filtro] != null &&
                                    ("" + p[filtro]).toUpperCase().indexOf(
                                        valoreFiltro.toUpperCase()
                                    ) !== -1;

                                return res;

                            });

                        }
                    }
                }
            })




            return listaResult;

        },

        filtroAtleti(tipoFiltro, valore) {

            this.searchTableAtleti = {};

            this.searchTableAtleti['tipoFiltro'] = tipoFiltro;
            this.searchTableAtleti['valoreFiltro'] = valore;

            this.configurazione = tipoFiltro.toUpperCase() + " " + valore

            this.elencoIscritti.forEach(item => {
                item.checked = undefined
            })

            this.selectAllRadio = false;

            this.itemsF2 = this.filteredTable();

            this.$forceUpdate();



        },


        filteredList() {
            var listaSearch = this.elencoIscritti;
            if (this.searchText !== '' && this.searchText != null) {

                listaSearch = this.elencoIscritti.filter((p) => {
                    let res =
                        p != null &&
                        p.cognome != null &&
                        p.cognome.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.team != null &&
                        p.team.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.pettorale != null &&
                        p.pettorale == this.searchText;

                    let res3 =
                        p != null &&
                        p.nome != null &&
                        p.nome == this.searchText;

                    let resTot = res || res1 || res2 || res3;
                    return resTot;
                });



            }

            this.direction = this.direction == 1 ? -1 : 1;
            listaSearch = listaSearch.sort(this.compareField);


            return listaSearch;
        },

        compareField(a, b, fieldName = null) {

            if (fieldName == null) fieldName = this.orderByField;
            if (fieldName == 'atleta') fieldName = 'cognome';

            const molti = this.direction;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },

        row_classes(item) {
            if (item.pettorale < 200) {
                //   return "orange"; //can also return multiple classes e.g ["orange","disabled"]
            }

            return "grey lighten-2 black--text"
        },

        line_classes(type, item) {
            console.log("line class:" + type + " " + JSON.stringify(item))
            if (type == 'timing') {
                if (item.timingpoint == 'Non definito')
                    return "white grey--text";
                else {
                    const tp = this.configRace.timingpoints.find(_item => {
                        return _item.name == item.timingpoint
                    })
                    if (tp != null) {
                        return tp.color;
                    }
                }
            }

        },

        printPrepare(printQR) {
            this.genQR = printQR
            if (printQR) this.showGenDialog = true
            this.print()
        },

        printCiclismo() {

            this.listaEtichette = [];

            const myArray = this.itemsF.filter(elem => {
                return elem.checked;
            })

            this.genQR = true
            this.showGenDialog = true

            for (var i = 0; i < myArray.length; i++) {

                const _url = this.getDataURL() + "getQR?pettorale=" + myArray[i].rowid + "&idIscrizione=SS&idGara=CHIPUG&divisione=CIC";
                this.getCall(_url).then((response) => {
                    this.listaEtichette.push(response);
                    const myArray = this.itemsF.filter(elem => {
                        return elem.checked;
                    });


                    if (this.listaEtichette.length == myArray.length) {
                        this.showGenDialog = false;
                        this.printEtichetteCiclismo();
                    }
                });

            }

        },


        print() {
            this.listaEtichette = [];

            const myArray = this.itemsF.filter(elem => {
                return elem.checked;
            })

            for (var i = 0; i < myArray.length; i++) {

                if (this.genQR) {
                    const _url = this.getDataURL() + "getQR?pettorale=" + myArray[i].pett + "&idIscrizione=" + myArray[i].rowid + "&idGara=" + this.raceID + "&divisione=" + myArray[i].divisione;
                    this.getCall(_url).then((response) => {
                        //  console.log(response)
                        this.listaEtichette.push(response);
                        const myArray = this.itemsF.filter(elem => {
                            return elem.checked;
                        });


                        if (this.listaEtichette.length == myArray.length) {
                            this.showGenDialog = false;
                            this.printEtichette();
                        }
                    });
                } else {
                    this.listaEtichette.push({ "idIscrizione": myArray[i].rowid, "pettorale": myArray[i].pett });
                    this.printEtichette();
                }

            }

        },


        printEtichette() {

            this.listaEtichette.sort((a, b) => {
                return a.pettorale - b.pettorale
            })



            const HEADERTABLE = "<body style='margin:0; font-family:Arial; font-size:10pt' >";
            const style2 = "<style>.classifica {font-family: Verdana;font-size: 11px;} .title {	font-family: Verdana;font-size: 20px;} .title2 {	font-family: Verdana;font-size: 16px; font-weight: bold; padding: 10px} td {	border-bottom:1px solid grey; vertical-align: top; }</style>";

            var result = "<table width='100%' cellpadding='0' cellspacing='0' border='0' style='border-color: lightgrey; margin-top:0cm; margin-bottom:0cm'>";

            result += "<tr style='font-size:10pt' >";
            for (var i = 0; i < this.listaEtichette.length; i++) {
                let item_ = this.itemsF.filter(elem => {
                    return elem.rowid == this.listaEtichette[i].idIscrizione;
                });
                if (i > 0 && i % 3 == 0) {
                    result += "</tr><tr style='font-size:10pt'>"
                }
                if (item_.length > 0) {
                    let item = item_[0];
                    if (this.genQR)
                        result += "<td style='width:6.8cm; height:5cm; padding-left:0.5cm; padding-top:0cm' align='left' ><table width='100%' cellpadding='0' cellspacing='0' border='0' style='margin-top:0cm; margin-bottom:0cm'><tr><td colspan=2 style='text-align: right; padding-right: 20px'><br><strong><span style='font-size:14pt'># " + item.pett + "</span><br><small><strong>" + item.cognomeL + " " + item.nomeL + "</strong><br>" + item.squadraL + "</small></td></tr><tr><td width='10%' style='vertical-align: top; text-align:center'><span style='margin-right:0px'></span><img width='100px' src='data:image/png;base64," + this.listaEtichette[i].qr + "'></td><td style='text-align: end; padding-right:20px'><small>Cat: " + item.categoria + "<br>Cod: " + item.codiceSquadra + "<br>ID: " + item.rowid + "</small></td></tr></table></td>";
                    else
                        result += "<td style='width:6.8cm; height:4cm; padding-left:0.3cm; padding-top:0.3cm' align='left' valign='center'>Num: <strong>" + item.pett + "<strong><span style='margin-left:30px'>" + item.categoria + "</span><br><br><small>" + item.cognome + ' ' + item.nome + "<br></small><br><small style='font-size:8pt'>" + item['codice squadra'] + " - " + item.squadra + "</small></td>";
                } else {
                    result += "<td style='width:6.8cm; height:4cm; padding-left:0.3cm; padding-top:0.3cm' align='left' valign='center'>ERRORE QR: " + this.listaEtichette[i].idIscrizione + "</td>";

                }


            }
            result += "</tr>";
            result += "</table>";

            // console.log(result)

            let myWin = window.open("", "displayWindow", "width=800,height=500,status=yes,toolbar=yes,menubar=yes");

            myWin.document.open();
            myWin.document.write("<html><head><title>ETICHETTE</title>");
            myWin.document.write("");
            myWin.document.write("</head><body onload='window.print()'>");
            //myWin.document.write(style2);

            myWin.document.write(HEADERTABLE);



            // myWin.document.write("<div class='hdr'>");

            myWin.document.write(result);

            // myWin.document.write("</div>");
            myWin.document.write("</body></html>");
            myWin.document.close();

            /* 
             */
        },



        printEtichetteCiclismo() {

            this.listaEtichette.sort((a, b) => {
                return a.pettorale - b.pettorale
            })



            const HEADERTABLE = "<body style='margin:0; font-family:Arial; font-size:10pt' >";
            const style2 = "<style>.classifica {font-family: Verdana;font-size: 11px;} .title {	font-family: Verdana;font-size: 20px;} .title2 {	font-family: Verdana;font-size: 16px; font-weight: bold; padding: 10px} td {	border-bottom:1px solid grey; vertical-align: top; }</style>";

            var result = "<table width='100%' cellpadding='0' cellspacing='0' border='0' style='border-color: lightgrey; margin-top:0cm; margin-bottom:0cm'>";

            result += "<tr style='font-size:10pt' >";
            for (var i = 0; i < this.listaEtichette.length; i++) {

                let item = this.listaEtichette[i];

                const codice =  item.pettorale.replace("TGUG", "");
                
                if (i > 0 && i % 2 == 0) {
                    result += "</tr><tr style='font-size:10pt'>"
                }
                result += "<td style='width:6.8cm; height:5cm; padding-left:0.5cm; padding-top:0cm' align='left' ><table width='100%' cellpadding='0' cellspacing='0' border='0' style='margin-top:0cm; margin-bottom:0cm'><tr><td colspan='2' style='text-align: right;padding-right: 20px;font-size:8pt;background-color:red;color: white;'>Chip usa e getta valido solo per la manifestazione odierna</td></tr><tr><td width='40%' style='vertical-align: top; text-align:center'><span style='margin-right:0px'></span><img width='130px' src='data:image/png;base64," + this.listaEtichette[i].qr + "'></td><td style='text-align: center;padding-top: 20px;'><img src='https://www.icron.it/live/assets/images/logo_icron_2.0.png' height='50px'></td></tr><tr><td colspan='2' style='text-align: center'><span style='font-size:16pt; background-color:red;color: white; border-radius: 3px; padding: 5px'>" + codice + "</span></td></table></td>";
            }
            result += "</tr>";
            result += "</table>";

            // console.log(result)

            let myWin = window.open("", "displayWindow", "width=800,height=500,status=yes,toolbar=yes,menubar=yes");

            myWin.document.open();
            myWin.document.write("<html><head><title>ETICHETTE</title>");
            myWin.document.write("");
            myWin.document.write("</head><body onload='window.print()'>");
            //myWin.document.write(style2);

            myWin.document.write(HEADERTABLE);



            // myWin.document.write("<div class='hdr'>");

            myWin.document.write(result);

            // myWin.document.write("</div>");
            myWin.document.write("</body></html>");
            myWin.document.close();

            /* 
             */
        },

    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

.frazioniTitle {
    text-align: left;
    _background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.orario {
    text-align: left;
    _background-color: #424242;
    _color: orange;
    _border-radius: 5px 5px 5px 5px;
    padding: 2px;
    min-width: 30px;
}

.orario2 {
    text-align: left;
    _background-color: #424242;
    _color: white;
    border-radius: 5px 5px 5px 5px;
    _padding: 5px;
    font-weight: bold;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniTitleFinale {
    text-align: center;
    background-color: orange;
    color: black;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    font-weight: bold;
}

.cardUp {
    background-color: lightgray;
    color: black;
    border: 3px solid white;
    border-radius: 0px 10px 10px 0px;
}

.cardUp2 {
    background-color: #e0e0e0;
    color: black;
    border: 5px solid white;
    border-radius: 15px 15px 15px 15px;
}

.cardStatsHeader {
    background-color: #212121;
    color: white;
    border-radius: 10px 10px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
}


table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
    padding: 2px;
}

.v-input {
    font-size: 14px;
}
</style>

